import { Paper } from "@commonlibs";
import { alpha } from "@commonlibs";
import styled, { css } from "styled-components";
import { ColoredPaperRootProps } from "./ColoredPaper.types";

export const ColoredPaperRoot = styled(Paper)<ColoredPaperRootProps>(({ background }) => {
    return css`
        background: ${alpha(background, 0.48)};
    `;
});
